import { render, staticRenderFns } from "./learn.math.vue?vue&type=template&id=54e2ae9d&scoped=true&"
import script from "./learn.math.vue?vue&type=script&lang=ts&"
export * from "./learn.math.vue?vue&type=script&lang=ts&"
import style0 from "./learn.math.vue?vue&type=style&index=0&id=54e2ae9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e2ae9d",
  null
  
)

export default component.exports